module.exports = __webpack_public_path__ + "static/media/home.f9a6a577.svg";